/* eslint-disable import/prefer-default-export */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ModelState from "../../../types/musicData";

interface value {
  value: any;
}

const initialState: ModelState = {
  current: null,
  uploadedImage: "",
  gifImage: null,
  items: {
    dress: "#fffff",
  },
};

export const appData = createSlice({
  name: "musicPlaying",
  initialState,
  reducers: {
    setDressColor: (state, action: PayloadAction<value>) => {
      state.items.dress = action.payload.value;
    },
    setCurrent: (state, action: PayloadAction<value>) => {
      state.current = action.payload.value;
    },
    setUploadedImage: (state, action: PayloadAction<any>) => {
      console.log("received action.payload", action.payload);
      state.uploadedImage = action.payload;
    },
    setGifImage: (state, action: PayloadAction<any>) => {
      console.log("image converted");
      state.gifImage = action.payload;
    },
  },
});

export const { setDressColor, setCurrent, setUploadedImage, setGifImage } =
  appData.actions;

export default appData.reducer;
